import React from "react";

interface BundleDrawerFooterProps {
  children?: React.ReactNode;
}

export const BundleDrawerFooter = ({ children }: BundleDrawerFooterProps) => {
  return (
    <div className="sticky bottom-0 border-0 border-t border-solid border-primary bg-white p-5 shadow-lg">
      {children}
    </div>
  );
};
